/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ChartParms } from "@src/app/model/sys/nav-item";
import { User } from "@src/app/model/user";
import { TxnPageComponent } from "@src/app/modules/txn/txn-page/txn-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const TxnPageNavRoute = new NavRoute('txns', ()=>TxnPageComponent, 'receipt_long').setCharts([
    { type: 'bar', picklist: 'typeId' } as ChartParms,
    { type: 'pie', picklist: 'bCodeId', number: 'credit', excludeZero: true } as ChartParms,
    { type: 'pie', picklist: 'bCodeId', number: 'debit', excludeZero: true } as ChartParms
]).setViews((u: User) => {
    return [
        {
            id: 'currentYear',
            name: 'Current Year',
            helpText: 'All ledger transactions for the current financial year; change the year filter to view a different year',
            filterFields: {
                txnCycleId: u.currentTeam.currentPeriod?.cycleId
            },
        }
    ]
});
